import React, { Component, Fragment } from 'react';
import PhoneSelect from 'components/PhoneSelect';
import PreviewPhone from 'components/PreviewPhone';

const PHONES_OPTIONS = [
  { value: 'iPhone8s', label: 'iPhone 8' },
  { value: 'iPhone10X', label: 'iPhone 10x' },
  { value: 'SamsungS8', label: 'Samsung S8' },
];

class PreviewMode extends Component {
  state = {
    value: PHONES_OPTIONS[0].value,
  };

  previewPhoneSelect = event => {
    this.setState({ value: event.target.value });
  };

  render() {
    return (
      <Fragment>
        <div className="h2-title">Preview</div>
        <PhoneSelect
          idSelect="preview-phone-select"
          classSelect="select appearance-none"
          labelText="Choose the phone"
          value={this.state.value}
          onChange={this.previewPhoneSelect}
          options={PHONES_OPTIONS}
        />

        <PreviewPhone selectedPhone={this.state.value} />
      </Fragment>
    );
  }
}

export default PreviewMode;



// WEBPACK FOOTER //
// ./src/components/PreviewMode/PreviewMode.js